import { Component, OnInit } from "@angular/core";
import Swal from "sweetalert2";
import { ApiService } from "../../../service/apiServices";
import { AuthService } from "../../../service/auth/auth.service";
import { Global } from "src/app/global";

@Component({
  selector: "app-list-plans",
  templateUrl: "./list-plans.component.html",
  styleUrls: ["./list-plans.component.css"],
})
export class ListPlansComponent implements OnInit {

  listaPlanos: any = { conteudo: [], quantidade_total: 0 };
  filtro: string = "";
  ano: number = new Date().getFullYear();
  pagina: number = 1;
  itensPorPagina: number = 10;
  totalPagina: number = 1;

  meses: any = {
    janeiro: 0,
    fevereiro: 0,
    marco: 0,
    abril: 0,
    maio: 0,
    junho: 0,
    julho: 0,
    agosto: 0,
    setembro: 0,
    outubro: 0,
    novembro: 0,
    dezembro: 0,
  };

  listaMeses = [
    { id: "janeiro", nome: "Janeiro" },
    { id: "fevereiro", nome: "Fevereiro" },
    { id: "marco", nome: "Março" },
    { id: "abril", nome: "Abril" },
    { id: "maio", nome: "Maio" },
    { id: "junho", nome: "Junho" },
    { id: "julho", nome: "Julho" },
    { id: "agosto", nome: "Agosto" },
    { id: "setembro", nome: "Setembro" },
    { id: "outubro", nome: "Outubro" },
    { id: "novembro", nome: "Novembro" },
    { id: "dezembro", nome: "Dezembro" },
  ];
  lista: any[] = [];
  constructor(
    public service: ApiService,
    private authService: AuthService,
    public global: Global
  ) {}

  ngOnInit() {
    Swal.fire("Favor aguarde");
    Swal.showLoading();

    this.pesquisar();
  }

  obterListaPlanos = () => {
    let url = `Plano?skip=${this.pagina}&take=${this.itensPorPagina}`;
    if (this.filtro && this.filtro.length >= 3) {
      url += `&busca=${this.filtro}`;
    }
    return new Promise((res, rej) => {
      this.service.Get(url).then(
        (result) => {
          res(result);
        },
        (error) => {
          rej(error);
        }
      );
    });
  };

  alterarStatusPlano = (item) => {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    item.ativo = !item.ativo;
    this.service.Put(`Plano/${item.id}`, item).then(
      (result) => {
        Swal.fire("Sucesso", "Plano alterado com sucesso", "success").then(
          (result) => {
            Swal.fire("Favor aguarde");
            Swal.showLoading();
            this.obterListaPlanos().then(
              (result) => {
                this.listaPlanos = result;
                Swal.close();
              },
              (error) => {
                Swal.fire("Erro", error.messagem, "error");
              }
            );
          }
        );
      },
      (error) => {
        Swal.fire("Error", error.messagem, "error");
      }
    );
  };

  alterarBloqueioPlano = (item) => {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    item.bloqueado = !item.bloqueado;
    this.service.Patch_body(`Plano/${item.id}/Bloqueado`, item.bloqueado).then(
      (result) => {
        Swal.fire("Sucesso", "Plano alterado com sucesso", "success").then(
          (result) => {
            Swal.fire("Favor aguarde");
            Swal.showLoading();
            this.obterListaPlanos().then(
              (result) => {
                this.listaPlanos = result;
                Swal.close();
              },
              (error) => {
                Swal.fire("Erro", error.messagem, "error");
              }
            );
          }
        );
      },
      (error) => {
        Swal.fire("Error", error.messagem, "error");
      }
    );
  };

  voltarPagina = () => {
    if (this.pagina >= 2) this.pagina = this.pagina - 1;
    this.obterListaPlanos();
  };

  pesquisar() {
    this.obterListaPlanos().then(
      (result) => {
        this.listaPlanos = result;
        
        this.totalPagina = Math.ceil(
          this.listaPlanos.quantidade_total / this.itensPorPagina
        );
        Swal.close();
      },
      (error) => {
        Swal.fire("Erro", error.messagem, "error");
      }
    );
  }

  onFiltroChange(value: string) {
    this.filtro = value;
    // Reset page to 1 before searching when user typed at least 3 characters
    if (value && value.length >= 3) {
      this.pagina = 1;
      this.pesquisar();
    }
  }

  salvarTetoMes() {
    const request = {
      agrupado: true,
      ano: this.ano,
      tetos: [
        { mes: "JANEIRO", quantidadeMaxConsultas: this.meses.janeiro || 0 },
        { mes: "FEVEREIRO", quantidadeMaxConsultas: this.meses.fevereiro || 0 },
        { mes: "MARCO", quantidadeMaxConsultas: this.meses.marco || 0 },
        { mes: "ABRIL", quantidadeMaxConsultas: this.meses.abril || 0 },
        { mes: "MAIO", quantidadeMaxConsultas: this.meses.maio || 0 },
        { mes: "JUNHO", quantidadeMaxConsultas: this.meses.junho || 0 },
        { mes: "JULHO", quantidadeMaxConsultas: this.meses.julho || 0 },
        { mes: "AGOSTO", quantidadeMaxConsultas: this.meses.agosto || 0 },
        { mes: "SETEMBRO", quantidadeMaxConsultas: this.meses.setembro || 0 },
        { mes: "OUTUBRO", quantidadeMaxConsultas: this.meses.outubro || 0 },
        { mes: "NOVEMBRO", quantidadeMaxConsultas: this.meses.novembro || 0 },
        { mes: "DEZEMBRO", quantidadeMaxConsultas: this.meses.dezembro || 0 },
      ],
    };   

    this.service.Post(`PlanoTetoMensal/TetoMensal`, request).then(
      (result) => {
        Swal.fire("Sucesso", "Teto mensal salvo com sucesso", "success");
      },
      (error) => {
        if (error.error && error.error.messagem) {
          Swal.fire("Erro", error.error.messagem, "error");
        } else {
          Swal.fire("Erro", error.messagem, "error");
        }
      }
    );
  }
}
